import { Box, Container, Grid, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { CustomContainedButton, Translate, Error404 } from '..'

interface NotFoundViewProps {
  origin?: string
  deleted?: boolean
  returnLocation?: string
}

export const NotFoundView = ({
  origin,
  deleted,
  returnLocation,
}: NotFoundViewProps) => {
  const navigate = useNavigate()
  origin = origin ? `${origin}.` : ''
  return (
    <Container maxWidth="md">
      <Grid
        container
        justifyContent={'center'}
        flexDirection={'column'}
        gap={'30px'}
        height={'60vh'}
      >
        <Grid
          item
          marginTop={'30px'}
          display={'flex'}
          justifyContent={'center'}
        >
          <Box maxWidth={'125px'}>
            <Error404 />
          </Box>
        </Grid>
        <Grid item textAlign={'center'} marginTop={'16px'}>
          <Typography variant="h4">
            {deleted ? (
              <Translate
                entityName={`${origin}404.title.deleted`}
                defaultMessage={'Online check-in form no longer exists'}
              />
            ) : (
              <Translate
                entityName={`${origin}404.title.notFound`}
                defaultMessage={'Online check-in form not found'}
              />
            )}
          </Typography>
          <Typography
            marginTop={'6px'}
            display={'inline-block'}
            textAlign={'center'}
            fontSize={'1rem'}
            fontWeight={400}
            lineHeight={'26px'}
            color={'#354967'}
          >
            {deleted ? (
              <Translate
                entityName={`${origin}404.text.deleted`}
                defaultMessage={
                  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.'
                }
              />
            ) : (
              <Translate
                entityName={`${origin}404.text.notFound`}
                defaultMessage={
                  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.'
                }
              />
            )}
          </Typography>
        </Grid>
        <Grid item display={'flex'} justifyContent={'center'}>
          <Translate
            entityName={`${origin}404.button`}
            defaultMessage={'Go somewhere'}
          >
            {(text) => {
              return text != 'false' ? (
                <CustomContainedButton
                  onClick={() => navigate(`/${returnLocation}`)}
                  color="primary"
                  variant="contained"
                >
                  {text}
                </CustomContainedButton>
              ) : <div/>
            }}
          </Translate>
        </Grid>
      </Grid>
    </Container>
  )
}
